import jQuery from 'jquery';
import raf from 'raf';
import getPrefix from 'get-prefix';

var createParallax = (function(controller) {
    'use strict';
    
    // We could get it to work on mobile, but that means introducing a third-party scrolling library, which then in turn
    // modifies the mechanics of the scrolling, changing it from its default behaviour, which many dislike.
    // Making it work on mobiles would also introduce a performance hinderence.
    // if(jQuery.browser.mobile) {
    //     return;
    // }
    
    var elements = { },
        parallaxElementsLength,
        windowHeight = window.innerHeight,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop,
        lastScrollTop = scrollTop,
        loopActive = false,
        scrollTimeout = null,
        transformPrefixed = getPrefix('transform');
    
    function getPositionY(element) {
        var rect = element.getBoundingClientRect();
        
        return scrollTop + rect.top;
    }
    
    function translate(element, x, y) {
        var transform = 'translateX(' + x + 'px) translateY(' + y + 'px)';
        
        element.style[transformPrefixed] = transform;
    }
    
    function applyParallax() {
        raf(function() {
            if(scrollTop === lastScrollTop) {
                if(loopActive) {
                    applyParallax();
                }
                
                return;
            }
            
            var parallaxElements = elements.parallaxElements,
                length = parallaxElementsLength,
                index,
                element,
                offset,
                friction,
                height,
                top,
                end,
                ratio,
                y;

            for(index = 0; index < length; ++index) {
                element = parallaxElements[index];

                offset = element.cachedOffset;
                friction = element.cachedFriction;
                height = element.cachedHeight;
                top = element.cachedTop;
                
                // Only process parallax elements that are in view
                if(scrollTop + windowHeight >= top && scrollTop <= top + height) {
                    end = top + height;
                    ratio = (scrollTop - offset) / (end - offset) / 2;

                    // Don't allow overflow
                    if(ratio > 1) ratio = 1;
                    if(ratio < 0) ratio = 0;

                    y = ~~(ratio * (friction * height));

                    translate(element, 0, y);
                }
            }
            
            if(loopActive) {
                applyParallax();
            }
            
            lastScrollTop = scrollTop;
        });
    }
    
    function beginLoop() {
        loopActive = true;
        
        applyParallax();
    }
    
    function endLoop() {
        loopActive = false;
    }

    /**
     * Runs on window scroll, unthrottled.
     * 
     * The actually parallax work is done outside of the scroll event, and inside of a animation frame loop.
     */
    function onWindowScroll() {
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if(!loopActive) {
            beginLoop();
        }
        
        if(scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        
        scrollTimeout = setTimeout(endLoop, 250);
    }
    
    function parseBreakpoints(breakpointsStr, currentBreakpoint) {
        var breakpoints = { };
        
        breakpointsStr.split(',').forEach(function(breakpointCouple) {
            var coupleSplit = breakpointCouple.split(':');
            
            if(coupleSplit.length !== 2) {
                return;
            }
            
            coupleSplit = coupleSplit.map(function(side, index) {
                return index ? parseInt(side, 10) : side.trim();
            });
            
            if(typeof coupleSplit[0] === 'string' && !isNaN(coupleSplit[1])) {
                breakpoints[coupleSplit[0]] = coupleSplit[1];
            }
        });
        
        if(typeof breakpoints[currentBreakpoint] === 'undefined') {
            return false;
        }
        
        return breakpoints[currentBreakpoint];
    }

    /**
     * Executes when the window is resized.
     * 
     * Throttled to run a maximum of once per 250ms
     */
    function onWindowResize() {
        // Iterate through and cache certain values
        var parallaxElements = elements.parallaxElements,
            length = parallaxElements.length,
            currentBreakpoint = controller.app.breakpointController.get(),
            index,
            element,
            offset,
            offsetRaw,
            friction;

        for(index = 0; index < length; ++index) {
            element = parallaxElements[index];

            offsetRaw = element.getAttribute('data-offset');
            friction = parseFloat(element.getAttribute('data-friction'));
            
            if ( ! offsetRaw) {
                offsetRaw = 0;
            }
            
            // Check for static integer value
            offset = parseInt(offsetRaw, 10);
            
            // Check for responsive offset value
            if(isNaN(offset)) {
                offset = parseBreakpoints(offsetRaw, currentBreakpoint);
            }

            // If invlaid offset, use default
            if(offset === false) {
                offset = 0;
            }

            // If invlaid friction, use default
            if(isNaN(friction)) {
                friction = 0.25;
            }

            element.cachedOffset = offset;
            element.cachedFriction = friction;
            element.cachedHeight = element.parentNode.offsetHeight;
            element.cachedTop = getPositionY(element.parentNode);

            element.cachedLastY = 0;
            element.cachedLastAnimation = null;
        }
    }

    /**
     * Cache element objects for later use
     */
    function cacheElements() {
        elements.parallaxElements = document.querySelectorAll('.parallax');
        
        parallaxElementsLength = elements.parallaxElements.length;
    }
    
    function setFixedListeners() {
        window.addEventListener('scroll', onWindowScroll, { passive: true });
        // window.addEventListener('resize', Helpers.throttledFunction(250, onWindowResize));
    }

    cacheElements();
    setFixedListeners();
    
    // Only initialize script if there is any parallax
    if(elements.parallaxElements.length) {
        onWindowResize();

        // setTimeout(function() {
        //     window.scrollTo(0, scrollTop + 1);
        // }, 100);
        //
        // setTimeout(function() {
        //     window.scrollTo(0, scrollTop + 1);
        // }, 1000);
    }
    
    return {
        elements: elements,
        cacheElements: cacheElements,
        resize: onWindowResize
    }
});

export default createParallax;